import { useMap } from "@vis.gl/react-google-maps";
import { useEffect, useMemo } from "react";
import { GoogleMapsOverlay } from "@deck.gl/google-maps";

export const DeckGLOverlay = ({ layers }) => {
  const map = useMap();
  const overlay = useMemo(() => new GoogleMapsOverlay(), []);

  // add the overlay to the map once the map is available
  useEffect(() => {
    overlay.setMap(map);

    return () => overlay.setMap(null);
  }, [overlay, map]);

  // whenever the rendered data changes, the layers will be updated
  useEffect(() => {
    overlay.setProps({ layers });
  }, [overlay, layers]);

  return null;
};
